export const TransactionStatus = ['success', 'fail', 'cancel', 'refunded', 'chargeback', 'on-hold', 'settled'];


// WEBPACK FOOTER //
// ./src/app/report/pg-detailed-transaction-report/transactionStatus.const.ts